import { equalHeight } from "../../common/equalHeight";

export default function applicationTilesEqualHeight() {
  const headers = document.getElementsByClassName(
    "application-tiles__tile-header",
  );

  headers.length > 0 && equalHeight(".application-tiles__tile-header");

  //application tiles content
  const applicationWrappers = Array.from(
    document.querySelectorAll(".application-tiles__tile-wrapper"),
  );

  applicationWrappers.forEach((el) => {
    let numberOfRows = 0;
    const applicationTiles = Array.from(
      el.querySelectorAll(".application-tiles__tile"),
    );

    applicationTiles.forEach((tile) => {
      let countChildrens = tile.querySelectorAll(
        ".application-tiles__tile-content",
      ).length;
      if (countChildrens > numberOfRows) {
        numberOfRows = countChildrens;
      }
    });

    for (let i = 0; i < numberOfRows; i++) {
      equalHeight(`.js-application-tiles__tile-row-${i}`);
    }
  });
}
